<template>
  <div class="mail-detail-dialog">
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" lock-scroll
      :destroy-on-close="true" append-to-body :before-close="cancel" class="audit-dialog">
      <div class="el-dialog-div">
        <!-- 快递单号信息 -->
        <div class="section-card">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-truck"></i> 快递单号信息</span>
          </div>
          <div class="tab-content">
            <el-form label-width="120px" ref="form" :model="form" :rules="rules">
              <div v-for="(mailNumber, index) in form.numbers" :key="index" class="mail-number-item">
                <el-form-item label="快递单号" :prop="'numbers.' + index + '.label'"
                  :rules="{ required: true, message: '请输入快递单号', trigger: 'change' }">
                  <el-input style="width: 360px;" v-model="mailNumber.label" placeholder="请输入快递单号"
                    auto-complete="off"></el-input>
                  <el-button style="margin-left: 10px" type="danger" size="small" icon="el-icon-delete"
                    @click="handleDelete(mailNumber)">删除</el-button>
                </el-form-item>
              </div>
              <el-form-item label="快递单号" prop="mailNumber.label"
                :rules="{ required: true, message: '请扫描快递单号或者输入快递单号', trigger: 'change' }">
                <scan-the-code style="width: 360px;" ref="courierNoInput" v-model="form.mailNumber.label"
                  placeholder="请扫描快递单号或者输入快递单号" :hasCleared="hasCleared"></scan-the-code>
                <el-button style="margin-left: 10px" size="small" type="danger" icon="el-icon-delete" class="title"
                  @click="handleDelete()">删除</el-button>
                <el-button style="margin-left: 10px" size="small" v-if="form.mailNumber.label" icon="el-icon-plus"
                  type="success" class="title" @click="handleAdd">添加</el-button>
              </el-form-item>
              <el-form-item label="邮寄情况" prop="mailFlag">
                <el-select style="width: 360px;" v-model="form.mailFlag" placeholder="请选择邮寄完成情况" filterable>
                  <el-option v-for="item in FlagOptions" :key="item.label" :label="item.name"
                    :value="item.label"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" class="title" @click="cancel">取消</el-button>
        <el-button size="small" class="title" @click="handle" type="primary">提交</el-button>
      </div>
    </el-dialog>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import {addMailNumber} from "@/api/dilivery/mail";
import FilePreview from "@/components/file/FilePreview.vue";
import ScanTheCode from "@/components/scanTheCode.vue";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "MailDetail",
  components: { ScanTheCode, FilePreview, Loading },
  props:['showDialog','selectDetail'],
  data(){
    return{
      title:'邮寄信息补全',
      loading:false,
      fileInfo:'',
      FlagOptions: [
        {label:false,name:'完成部分邮寄，快递单号未添加完成'},
        {label:true,name:'已完成全部邮寄，快递单号添加完成'}
      ],
      hasCleared: false,
      status:'',
      rejectionReason:'',
      operatingTime:'',
      operatingPersonName:'',
      mailFlag: '',
      mail: {},
      form:{
        id:'',
        mailNumber: {label:''},
        mailNumbers:[],
        numbers: [],
        mailFlag:true,
      },
      rules:{
      }
    }
  },
  watch:{
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.mailFlag = newVal.mailFlag
          this.mail.numbers = newVal.mailNumbers
          this.mail.mailNumbers = Object.keys(newVal.mailNumbers)
        }
      },
      immediate:true
    },
  },
  mounted() {
  },
  methods:{
    handleDelete(item) {
      if(item){
        const index = this.form.numbers.indexOf(item)
        if (index !== -1) {
          this.form.numbers.splice(index, 1)
        }
      }else{
        let lastElement = this.form.numbers.pop();
        if(lastElement){
          this.form.mailNumber = lastElement
        }else{
          this.form.mailNumber = {label: ''}
        }
      }
    },
    handleAdd() {
      if(this.form.mailNumber.label){
        const mailNumber = {label:this.form.mailNumber.label}
        this.form.numbers.push(mailNumber)
        this.form.mailNumber.label = ''
      }else{
        this.$messageUi.error('')
      }
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      this.$refs.form.validate(valid=>{
        if(valid){
          this.loading = true
          this.form.mailNumbers = this.form.numbers.map(item => item.label)
          this.form.mailNumbers.push(this.form.mailNumber.label)
          addMailNumber(this.form).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$messageUi.success('添加成功')
              this.$store.commit('right/setChangeRed',true)
              this.$emit('submit','confirm')
            }
          }).catch(err => {
            this.loading = false
          })
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.mail-detail-dialog {
  ::v-deep .audit-dialog {
    .el-dialog__header {
      
      padding: 15px 20px;
      
       .el-dialog__title {
        font-weight: 600;
      }
      
      
    }
    
    .el-dialog__body {
      padding: 20px;
    }
  }
}
@import "@/assets/css/mixins.scss";
@import "@/assets/css/detail.css";
.el-dialog-div {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 5px;
  
  @include thin-scrollbar(8px, #888);
}

.mail-number-item {
  margin-bottom: 10px;
  padding: 10px;
  background: #fafbfc;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}
</style>
